// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";

//vue-router
import router from "./router";
import store from './store'

//mint-ui
import "mint-ui/lib/style.css";
import mint from "mint-ui";
import { Indicator, Toast, MessageBox } from "mint-ui";
Vue.use(mint)
Vue.prototype.Toast = Toast;
Vue.prototype.Indicator = Indicator;
Vue.prototype.MessageBox = MessageBox;
import lrz from 'lrz'//压缩图片
// const FastClick = require('fastclick')
// FastClick.attach(document.body)
//vant-ui
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
import Cookies from 'js-cookie'
Vue.prototype.Cookies = Cookies
import GLOBLE from './globle/globle'
Vue.prototype.$G = GLOBLE
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(ElementUI);
Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js